import chalk from 'chalk';
import {Command} from 'commander';
import {generateCompletionScript} from './completion/index.js';

export const createCompletionCommand = (): Command => {
  const command = new Command('completion');

  command
    .description(
      [
        chalk.bold('Setup shell completion for rawi.'),
        '',
        chalk.gray(
          'Copies completion scripts to ~/.rawi/completion/ and optionally',
        ),
        chalk.gray(
          'installs them to your shell profile for automatic loading.',
        ),
        '─'.repeat(80),
      ].join('\n'),
    )
    .option(
      '-s, --shell <shell>',
      chalk.white('Shell type (bash, zsh, fish, or auto-detect)'),
      'auto',
    )
    .option(
      '--install',
      chalk.white('Install completion script to shell profile'),
      false,
    )
    .addHelpText(
      'after',
      [
        '',
        chalk.yellow('Examples:'),
        '',
        '  # Copy completion for current shell',
        '  $ rawi completion',
        '',
        '  # Copy for specific shell',
        '  $ rawi completion --shell bash',
        '  $ rawi completion --shell zsh',
        '  $ rawi completion --shell fish',
        '',
        '  # Copy and install to shell profile automatically',
        '  $ rawi completion --install',
        '  $ rawi completion --shell bash --install',
        '',
        '  # Files are copied to:',
        '  ~/.rawi/completion/rawi-completion.bash',
        '  ~/.rawi/completion/rawi-completion.zsh',
        '  ~/.rawi/completion/rawi-completion.fish',
        '',
        chalk.gray('After installation, restart your shell or run:'),
        chalk.gray('  source ~/.bashrc  # bash'),
        chalk.gray('  source ~/.zshrc   # zsh'),
        chalk.gray('  source ~/.config/fish/config.fish  # fish'),
      ].join('\n'),
    )
    .action(async (options) => {
      await generateCompletionScript(options);
    });

  return command;
};
